export const TEXT_MAP = {
    de: {
        labels: {
            chemicalFormula: 'Chemische Formel',
            elementsPresent: 'Elemente vorhanden',
            elementsAbsent: 'Elemente fehlen',
            minimumDistinct: 'Minimale unterschiedliche Elemente',
            maximumDistinct: 'Maximal unterschiedliche Elemente'
        },
        selectDefault: 'Wählen'
    },
    en: {
        labels: {
            chemicalFormula: 'Chemical formula',
            elementsPresent: 'Elements present',
            elementsAbsent: 'Elements absent',
            minimumDistinct: 'Minimum distinct elements',
            maximumDistinct: 'Maximum distinct elements'
        },
        selectDefault: 'Select'
    },
    es: {
        labels: {
            chemicalFormula: 'Fórmula química',
            elementsPresent: 'Elementos presentes',
            elementsAbsent: 'Elementos ausentes',
            minimumDistinct: 'Elementos distintos mínimos',
            maximumDistinct: 'Elementos distintos máximos'
        },
        selectDefault: 'Seleccionar'
    },
    fr: {
        labels: {
            chemicalFormula: 'Formule chimique',
            elementsPresent: 'Éléments présents',
            elementsAbsent: 'Éléments absents',
            minimumDistinct: 'Minimum d\'éléments distincts',
            maximumDistinct: 'Maximum d\'éléments distincts'
        },
        selectDefault: 'Sélectionner'
    },
    it: {
        labels: {
            chemicalFormula: 'Formula chimica',
            elementsPresent: 'Elementi presenti',
            elementsAbsent: 'Elementi assenti',
            minimumDistinct: 'Minimo elementi distinti',
            maximumDistinct: 'Massimo elementi distinti'
        },
        selectDefault: 'Selezionare'
    },
    ru: {
        labels: {
            chemicalFormula: 'Химическая формула',
            elementsPresent: 'Элементы присутствуют',
            elementsAbsent: 'Элементы отсутствуют',
            minimumDistinct: 'Минимум различных элементов',
            maximumDistinct: 'Максимум различных элементов'
        },
        selectDefault: 'Выбирать'
    }
};

export default TEXT_MAP;
